import {useDialogProvider} from './DialogProvider';

export type HTMLDialogState = {
  title: string;
  body: string;
};

export const useHTMLDialog = () => {
  const dialog = useDialogProvider<HTMLDialogState>();
  const open = dialog.state?.type === 'html';
  const setOpen = (params: HTMLDialogState) => {
    dialog.setState({type: 'html', ...params});
  };

  return {
    ...dialog,
    open,
    setOpen,
  };
};
